import idair from "../assets/funding/idair.png";
import cmc from "../assets/funding/cmc22.png";
// import wellcome from "../assets/funding/wellcome_bg.jpg";
import wellcome from "../assets/funding/wellcome_rb.png";
import varian from "../assets/funding/varian.jpeg";
import icmr from "../assets/funding/icmr.png";
import CATCH from "../assets/funding/INDIAAI-NCG.png";


export const fundingData = [
    {
        "title": "Fluid Research Major Grant 2021-22",
        "image": cmc,
    },
    {
        "title": "Early Career Fellowship 2020-24",
        "image": wellcome,
    },
    {
        "title": "Pathfinder project grant",
        "image": idair,
    },
    {
        "title": "",
        "image": varian,
    },
    {
        "title": "IndiaAI-NCG CATCH Grant for Cancer 2026",
        "image": CATCH,
    },
    {
        "title": "CMC-CDAC joint Grant 2024-27",
        "image": icmr,
    },
]